import Model from "@/lib/model/model";
import Auth from "@/lib/common/auth";
import _ from "lodash-es";
import request from "@/lib/request/request";
//zmn常住地址字段 value格式
export class ZmnHomeType extends Model {
  value: string[] = []; //省市区汉字
  codeValue: string[] = []; //省市区code码
  detailValue = ""; //详细住址
  longitude = 0; //经度
  latitude = 0; //纬度

  provinceId = "";
  cityId = "";
  countyId = "";
  address = "";
}

//zmn门店选择字段 value格式
export class ZmnStoreType extends Model {
  value = ""; //门店名称
  storeCode = ""; //门店code
  storeAddress = ""; //门店地址
  storeManager = ""; //门店负责人
  storeManagerPhone = ""; //门店负责人电话
  longitude = 0; //经度
  latitude = 0; //纬度
  polyLine: number[] = [0]; //路线画点
  useTime = 0; //预计用时 分钟
  useDistance = 0; //预计路程 米
}

export class ZhuoMuNiao extends Model {
  static zmnHomeText = "常住地址"; //特判项名称
  static zmnStoreText = "门店选择"; //特判项名称
  static zmnInputType = "zmnStore"; //特判项类型
  // 可选变量
  static tagListFilter(paramList: any[]) {
    const list = _.cloneDeep(paramList);
    const tagList = list.reduce((targetList, param: any) => {
      // 产品定：二级单选、二级多选、文件等类型不展示；
      if (
        !(
          [ZhuoMuNiao.zmnHomeText, ZhuoMuNiao.zmnStoreText].includes(
            param.name
          ) && param.inputType.localeCompare(ZhuoMuNiao.zmnInputType) === 0
        ) &&
        !["choice2", "multiChoice2", "file"].includes(param.inputType)
      ) {
        targetList.push(param);
      }
      return targetList;
    }, []);
    return tagList;
  }
  static getListStoreName(tem: string, name: string) {
    const str = ZhuoMuNiao.tagList[0];
    tem = tem.replace(RegExp(`{${str.name}}`, "g"), name);
    return tem;
  }
  static getListStoreAddress(tem: string, address: string) {
    const str = ZhuoMuNiao.tagList[1];
    tem = tem.replace(RegExp(`{${str.name}}`, "g"), address);
    return tem;
  }
  // 取列表中的地图项-特判当前地图是否允许配置
  static getListMap(tem: string, data: any) {
    const map = ZhuoMuNiao.tagList[2];
    const mapList = tem.match(RegExp(`{${map.name}}`, "g")) || [];
    if (mapList && mapList.length > 0) {
      for (const i in mapList) {
        // ${data.useDistance && data.useTime ? "<span>，</span>" : ""}
        const str = `
				<div class="map mapC${i}">
            <div id="container${i}" class="container"></div>
            <div class="tip">
							<span>提示：门店距您常住地约${Number((+data.useDistance ?? 0) / 1000).toFixed(
                2
              )}公里，公交通勤约${data.useTime}分钟</span>
            </div>
            <div class="map-footer">
              <span class="toMap">点击打开腾讯地图</span>
            </div>
          </div>
				`;
        tem = tem.replace(`{${map.name}}`, str);
      }
    }
    return { template: tem, mapList: mapList };
  }
  static getListReceiverName(tem: string, name: string) {
    const str = ZhuoMuNiao.tagList[3];
    tem = tem.replace(RegExp(`{${str.name}}`, "g"), name);
    return tem;
  }
  static getListReceiverPhone(tem: string, phone: string) {
    const str = ZhuoMuNiao.tagList[4];
    tem = tem.replace(
      RegExp(`{${str.name}}`, "g"),
      `<span class="tell">${phone}</span>`
    );
    return tem;
  }
  // 线下面试时间
  static getListReceiverTime(tem: string, time: string) {
    const str = ZhuoMuNiao.tagList[5];
    tem = tem.replace(RegExp(`{${str.name}}`, "g"), time);
    return tem;
  }
  static tagList = [
    {
      name: "啄木鸟门店-门店名称"
    },
    {
      name: "啄木鸟门店-门店地址"
    },
    {
      name: "啄木鸟门店-门店地址-地图"
    },
    {
      name: "啄木鸟门店-接待人姓名"
    },
    {
      name: "啄木鸟门店-接待人手机号"
    },
    {
      name: "期望参加线下面试的时间"
    }
  ];
  static zmnJson(value: string) {
    if (value) {
      try {
        const valueInfo = JSON.parse(value);
        return valueInfo;
      } catch (error) {
        return value;
      }
    } else {
      return value;
    }
  }
  static isZmn(paramList: any[]) {
    const list = _.cloneDeep(paramList);
    const zmnHome = list.find(item =>
      ZhuoMuNiao.judgment(item, ZhuoMuNiao.zmnHomeText)
    );
    const zmnStore = list.find(item =>
      ZhuoMuNiao.judgment(item, ZhuoMuNiao.zmnStoreText)
    );
    return !!zmnHome && !!zmnStore;
  }
  static isCompanyZmn() {
    const companyAcm = localStorage.getItem("ConfigCache_company_config");
    let isCompanyZmn = false;
    if (companyAcm) {
      try {
        isCompanyZmn =
          JSON.parse(companyAcm)[parseInt(Auth.companyId)].isCompanyZmn === 1;
      } catch (error) {
        console.log(error);
      }
    }
    return isCompanyZmn;
  }
  // 判断条件
  static judgment(param: any, targetName: string) {
    return (
      param.inputType.localeCompare(ZhuoMuNiao.zmnInputType) === 0 &&
      param.name.localeCompare(targetName) === 0
    );
  }
  static passTemplate = `
	恭喜！您已通过面试。<br />
	尊敬的{姓名}, 我们很高兴地通知您，您已成功通过我们的AI面试流程。<br />
	您在中面试中展示了卓越的技能和潜力，我们对您的表现印象深刻，希望进一步沟通与您合作。<br />
	接下来，我们将与您协商更多细节，包括更深入的面试或可能的下一步。<br />
	请保持您的电话和电子邮件畅通<br />
	如果您有任何问题，随时和我们联系`;
  static refuseTemplate = `尊敬的{姓名}, 感谢您参与了我们的AI面试。<br />
	我们非常感激您投入的时间。<br />
	经过慎重的考虑和评估，我们认为您与该岗位不匹配。<br />
	该结果仅代表您与该岗位的匹配度，我们将和您保持长期联系。<br />
	如果您有任何关于面试结果的问题，请随时与我们联系。<br /> 
	再次感谢您的关注，祝愿您在职业道路上一切顺利`;
  static waitTemplate = `尊敬的{姓名}，感谢您参与我们的AI面试。<br />
	您的面试表现令人印象深刻，我们对您的兴趣和潜力表示赞赏。<br />
	目前您的面试结果处于待定状态。<br />
	我们正在认真考虑每位候选人的背景和技能，以确保最终的决策能够与我们的需求和团队的文化相匹配。<br />
	我们将尽快完成评估，并与您联系。<br />
	在此期间，如果您有任何问题，可以随时与我们沟通。`;
}

export class PaperResult extends Model {
  isCompanyZmn = false;
  value = "未反馈";
}
export default class ResultDetails extends Model {
  examId = 0;
  exist = false;
  extraData = "";
  passTemplate = ZhuoMuNiao.passTemplate;
  refuseTemplate = ZhuoMuNiao.refuseTemplate;
  waitTemplate = ZhuoMuNiao.waitTemplate;

  // 获取面试结果页模版信息
  static get(connectCode: string) {
    return request
      .post("aiExam/resultPublic/templateGet", { connectCode: connectCode })
      .then(resp => {
        const result = new ResultDetails();
        if (resp.data.data.exist) {
          result.assign(resp.data.data);
        } else {
          result.examId = resp.data.data.examId;
          result.extraData = resp.data.data.extraData;
        }
        return result;
      });
  }
  // 保存候选人的面试模版页收集信息
  static save(params: string) {
    return request
      .post("aiExam/candidatePublic/saveResultData", params)
      .then(resp => {
        return resp.data.data;
      });
  }
  // 获取候选人信息
  static getCandidate(params: any, url = "aiExam/auditPublic/connect") {
    return request.post(url, params).then(resp => {
      return resp.data.data;
    });
  }
  static getMainColor(p = {}) {
    return request.post("/aiExam/auditPublic/getUserConfig", p).then(resp => {
      return resp.data.data.companySpecialConfig.styleConfig.mainColor;
    });
  }
  // 重复面试条件判断接口
  static check(connectCode: string, phone: string) {
    return request
      .post("/aiExam/old/check", {
        connectCode: connectCode, // 考试码
        phone: phone
      })
      .then(resp => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return resp.data.data;
      });
  }
  static getMobileUrl(code: string) {
    return request
      .post("/aiExam/common/url", {
        connectCode: code
      })
      .then(resp => {
        return resp.data;
      });
  }
  // ATS回调
  static tryCallback(code: string) {
    return request
      .post("/aiExam/old/tryCallback", {
        connectCode: code,
        must: true,
        isAddInfo: 1
      })
      .then(resp => {
        console.log("resp:", resp);
        return resp.data;
      });
  }
}
